<!-- 资源下载 -->
<template>
  <div v-if="resourceList.length > 0" class="resource-download-card">
    <div class="main">
      <div class="card-title">{{ $t("download.resourceDownloads") }}</div>
      <ul class="resource-list">
        <li
          v-for="(item, index) in resourceList"
          :key="index"
          class="source-item"
        >
          <span class="title">{{ item.sourceName }}</span>
          <a class="download no-select" @click="download(item)">{{ $t("download.download") }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref, inject, watch, renderSlot } from "vue";
import { getResListApi } from "@/api/developer";
import { downloadFile } from "@/utils/downloadFile";
import {getMyInfoApi} from "@/api/control";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const props = defineProps({
  resourceList: {
    type: Array,
    default: () => [],
  },
});

const download = (item) => {
  if (!item.downloadUrl) return;
  getMyInfo((result) => {
    if(result === 'error'){
      location.reload()
    }else{
      downloadFile(item.downloadUrl);
    }
  })
  
};

const getMyInfo = (callback) => {
  getMyInfoApi().then(res => {
    if(res.result.authenticationResult === 2200){
      callback()
    }else{
      callback('error')
      
    }
    
  }).catch(err => { console.log(err); })
};
</script>

<style lang="scss" scoped>
.resource-download-card {
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  caret-color: transparent;
  margin-bottom: 16px;
  ul,
  li {
    margin: 0;
    padding: 0;
  }
  .main {
    padding: 24px 24px 32px;
    .card-title {
      font-size: 20px;
      font-weight: bold;
      line-height: 33.6px;
      text-align: left;
      color: #333333;
    }
    .resource-list {
      margin-top: 24px;
      .source-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        line-height: 36px;
        text-align: left;
        margin-top: 16px;
        .title {
          color: #333333;
        }
        .download {
          font-weight: bold;
          color: #386aea;
          cursor: pointer;
        }
        &:first-child {
          margin-top: 0;
        }
      }
    }
  }
}
</style>
